import React from 'react';
import BaseSelectField from '../BaseSelectField';
import { lifeCycleEntitiesMap, selectFieldNames } from '../../constants';
import { useRoomAcceptanceStatusesQuery } from '../../../../api/roomAcceptanceStatuses';
import { useAddressId } from '../../services/propsProvider';

const settings = {
  name: selectFieldNames[lifeCycleEntitiesMap.acceptanceStatus],
  label: 'Результат приемки',
};

const SelectAcceptanceStatus = () => {
  const addressId = useAddressId();

  const { data, isFetching, refetch } = useRoomAcceptanceStatusesQuery({
    params: { addressId },
  });

  return (
    <BaseSelectField
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg="Не удалось загрузить список доступных результатов приемки"
      fieldSettings={settings}
    />
  );
};

export default SelectAcceptanceStatus;
